import { PointType } from "~/service/experience/world/nido/enum"

export class Point {
  position: THREE.Vector3
  component: Component
  active: boolean
  parentId: string
  type: PointType

  constructor(
    position: THREE.Vector3,
    component: Component,
    active: boolean,
    parentId: string,
    type: PointType
  ) {
    this.position = position
    this.component = component
    this.active = active
    this.parentId = parentId
    this.type = type
  }

  setActive(active: boolean) {
    this.active = active
  }
}